<template>
  <div class="float-buttons" v-if="whatsapp">
    <v-btn
      v-if="whatsapp"
      :href="getWhatsappLinkFromPhone(whatsapp)"
      target="_blank"
      color="#25D366"
      class="white--text text-none text-h6 btn"
      height="56"
      width="56"
      min-width="56"
      rounded
    >
      <v-icon size="26">fab fa-whatsapp </v-icon>
    </v-btn>
  </div>
</template>

<script>
import { getWhatsappLinkFromPhone } from "../../utils/getWhatsappLinkFromPhone";

export default {
  computed: {
    whatsapp() {
      return this.$rest("informations-contacts").item.whatsapp_float;
    },
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    getWhatsappLinkFromPhone,
  },
};
</script>

<style lang="scss" scoped>
.float-buttons {
  align-items: flex-end;
  bottom: 15px;
  display: flex;
  flex-direction: column;
  position: fixed;
  right: 15px;
  width: 0;
  z-index: 999;
  .btn {
    .item {
      height: 0;
      overflow: hidden;
      transition: all 0.1s linear;
      &.item--active {
        height: 24px;
      }
    }
  }
}
</style>
